import React, { Component } from 'react';
import './oauth.scss';
import strings from "../../locals/string.json";
import { Link } from "react-router-dom";
import routes from "../../constants/routes";
import { validateLoginDetails } from "../../constants/validation";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as userActions from '../../store/domain/user/action';
import ForgotPWModal from "./forgotPWModal";
import constants, { __DEV__ } from "../../constants/constants";
import { loginUser, register } from "../../service/auth";
import qs from "qs";
import Cookies from "js-cookie";
import { createETUserRegDetails, createUser } from "../../constants/commonFunc";
import { ToastUtil } from "../../constants/toastUtil";
import moment from "moment";

const login = strings.login;

class Login extends Component {

    state = {
        modelOpen: false,
        username: __DEV__ ? 'udarap@ceyentra.com' : '',
        password: __DEV__ ? '12345678' : '',
        etUser: false
    }

    componentWillMount() {
        // this.clearUserData()
        if (Cookies.get(constants.ACCESS_TOKEN) !== undefined) {
            this.props.history.push(routes.home)
        } else {
            this.clearUserData()
        }

        this.setState({
            etUser: this.props.location?.state?.error !== undefined &&
                this.props.location?.state?.error === 602
        })
    }

    clearUserData = () => {
        localStorage.removeItem(constants.USER_ORIGINAL_OBJ);
        Cookies.remove(constants.ACCESS_TOKEN)
        localStorage.removeItem(constants.ACCESS_TOKEN);
        localStorage.removeItem(constants.USER_OBJ);
    }

    onLogin = () => {
        if (validateLoginDetails(this.state)) {
            const data = {
                username: this.state.username,
                password: this.state.password,
                grant_type: 'password'
            }
            loginUser(qs.stringify(data), this.state.etUser)
                .then(response => {
                    if (response.success) {
                        if (!this.state.etUser) {
                            localStorage.setItem(constants.USER_ORIGINAL_OBJ, JSON.stringify(response.user));
                            Cookies.set(constants.ACCESS_TOKEN, response.access_token);
                            localStorage.setItem(constants.ACCESS_TOKEN, response.access_token);
                            localStorage.setItem(constants.USER_OBJ, JSON.stringify(createUser(response.user)));
                            this.props.setAuth(createUser(response.user));
                            this.props.setUserType(constants.USER_SELLER);
                            //this.props.location?.state?.fromReg ? this.props.history.push(routes.home) : this.props.history.goBack();

                            if (sessionStorage.getItem(constants.VIEW_TENDER) !== undefined) {
                                const tenderURL = sessionStorage.getItem(constants.VIEW_TENDER)
                                if (tenderURL === null) {
                                    this.props.history.push(routes.tenders)
                                } else {
                                    this.props.history.push(tenderURL)
                                }
                            } else {
                                if (localStorage.getItem(constants.REDIRECT_TO_HOME) !== undefined && localStorage.getItem(constants.REDIRECT_TO_HOME) === "true") {
                                    this.props.history.push(routes.home)
                                } else {
                                    // this.props.history.goBack()
                                    this.props.history.push(routes.home)
                                }
                            }

                        } else {
                            this.register(response.user)
                        }
                    } else {
                        ToastUtil.showErrorToast(response.msg);
                    }
                })
        }
    }

    register = (user) => {
        register(createETUserRegDetails({ ...user, password: this.state.password, ...user.account }))
            .then(response => {
                if (response.success) {
                    this.setState({ etUser: false })
                    this.onLogin();
                } else {
                    ToastUtil.showErrorToast(response.msg)
                }
            })
    }

    render() {

        return <div className="register-page-area pd-bottom-100 login">

            <div className="container">
                <div className="justify-content-center">
                    <h1 className="page-title">{login.welcome}</h1>
                    <div className="col-xl-4 col-lg-5 col-md-6 mb-5 mb-md-0">
                        <div className="contact-form-wrap contact-form-bg form">
                            <h4>{login.login}</h4>
                            <div className='mt-1 mb-2 login-Alert'>
                                <p>
                                <span className='req-star'>*</span>{login.loginAlert}
                                </p>
                            </div>
                            <div className="rld-single-input">
                                <input type="email" value={this.state.username}
                                    onChange={event => this.setState({ username: event.target.value })}
                                    placeholder={login.email}
                                    onKeyDown={e => e.keyCode === 13 ? this.onLogin() : null}
                                />
                            </div>
                            <div className="rld-single-input">
                                <input type="password" value={this.state.password}
                                    onChange={event => this.setState({ password: event.target.value })}
                                    placeholder={login.password}
                                    onKeyDown={e => e.keyCode === 13 ? this.onLogin() : null}
                                />
                            </div>
                            <div className="btn-wrap">
                                <button className="btn btn-yellow loginBtn"
                                    onClick={this.onLogin}>{login.login}</button>
                                <p className="forgotPW"
                                    onClick={() => this.setState({ modelOpen: !this.state.modelOpen })}>{login.forgotPW}</p>
                            </div>
                          
                            <p className="dont">{login.dontHave}
                                <p>&nbsp;<Link to={routes.register}><span
                                    className="lbl-register">{login.register}</span></Link></p>
                            </p>

                        </div>
                    </div>
                </div>
            </div>
            <ForgotPWModal
                open={this.state.modelOpen}
                close={() => this.setState({ modelOpen: !this.state.modelOpen })}
            />
        </div>
    }
}

const mapDispatchToProps = (dispatch) => ({
    setAuth: data => dispatch(userActions.setAuth(data)),
    setUserType: data => dispatch(userActions.setUserType(data)),
});

export default connect(null, mapDispatchToProps)(withRouter(Login));
